(ns manage.adset-decision-tree-page.view.side-panel.util
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Collapse$default" :as Collapse]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/ListItem$default" :as ListItem]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [uix.core :as uix :refer [$ defui]]))

(defui collapsible-wrapper [{:keys [label
                                    collapsed-label
                                    header-content
                                    initially-collapsed
                                    children]}]
  (let [[collapsed set-collapsed] (uix/use-state initially-collapsed)]
    ($ Stack {:direction "column"}
       ($ Stack {:direction "row"
                 :alignItems "center"}
          ($ Typography {:variant "h3"
                         :mt 1
                         :mb 2
                         :sx #js {:flex 1}}
             (if collapsed
               (or collapsed-label label)
               label))
          ($ Box {}
             header-content)
          ($ IconButton {:onClick (fn [^js _event]
                                    (set-collapsed (not collapsed)))}
             ($ Icon (if collapsed "expand_more" "expand_less"))))
       ($ Collapse {:in (not collapsed)
                    :sx #js {:width "100%"}}
          children))))

(defui condition-group-title-bar [{:keys [on-delete label]}]
  ($ Stack {:direction "row"
            :alignItems "center"
            :sx #js {:mb 0.5
                     :ml 1}}
     ($ Typography {:variant "h4"
                    :align "center"
                    :text-transform "uppercase"}
        label)
     ($ IconButton {:on-click on-delete
                    :disabled (not on-delete)
                    :sx #js {:ml "auto"
                             :color "grey.10"}}
        ($ Icon "delete_outline"))))

(def grey-container-sx
  #js {:borderRadius 2
       :p 1
       :mb 1
       :backgroundColor "grey.80"
       :border 2
       :borderColor "grey.80"
       ".MuiInputBase-root" #js {:backgroundColor "background.paper"}})

(defui condition-group-item
  [{:keys [on-delete delete-disabled label children]}]
  ($ ListItem {:sx grey-container-sx}
     ($ Stack {:width "100%"}
        ($ condition-group-title-bar
           {:on-delete (when-not delete-disabled on-delete)
            :label label})
        children)))
